import { createSelector } from "../reselect";
import { getNewStats, total, simpleChart, safeDivide, simpleChart2 } from "../generalUtils";

const providerId = "postscript";

const postscriptRevenue = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "conversion_value")
);
const postscriptRevenueChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "conversion_value")
);


const postscriptSent = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "sent")
);
const postscriptSentChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "sent")
);

const postscriptSubscribed = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "subscribed")
);
const postscriptSubscribedChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "subscribed")
);


const postscriptUnsubscribed = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "unsubscribed")
);
const postscriptUnsubscribedChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "unsubscribed")
);

const postscriptConversions = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "conversions")
);
const postscriptConversionsChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "conversions")
);

const postscriptDelivered = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "delivered")
);
const postscriptDeliveredChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "delivered")
);

const postscriptClicks = createSelector([getNewStats], (stats) =>
  total(stats[providerId], "clicks")
);
const postscriptClicksChart = createSelector([getNewStats], (stats) =>
  simpleChart(stats[providerId], "clicks")
);

const postscriptAov = createSelector(
  [postscriptRevenue, postscriptConversions],
  (postscriptRevenue, postscriptConversions) => {
    return safeDivide(postscriptRevenue, postscriptConversions);
  }
);
const postscriptAovChart = createSelector(
  [postscriptRevenueChart, postscriptConversionsChart],
  (postscriptRevenueChart, postscriptConversionsChart) =>
    simpleChart2(postscriptRevenueChart, postscriptConversionsChart)
);

const postscriptCtr = createSelector(
  [postscriptClicks, postscriptDelivered],
  (postscriptClicks, postscriptDelivered) => {
    return safeDivide(postscriptClicks, postscriptDelivered);
  }
);
const postscriptCtrChart = createSelector(
  [postscriptClicksChart, postscriptDeliveredChart],
  (postscriptClicksChart, postscriptDeliveredChart) =>
    simpleChart2(postscriptClicksChart, postscriptDeliveredChart)
);


const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    postscriptRevenue,
    postscriptRevenueChart,
    postscriptSent,
    postscriptSentChart,
    postscriptSubscribed,
    postscriptSubscribedChart,
    postscriptUnsubscribed,
    postscriptUnsubscribedChart,
    postscriptConversions,
    postscriptConversionsChart,
    postscriptAov,
    postscriptAovChart,
    postscriptCtr,
    postscriptCtrChart,
    postscriptDelivered,
    postscriptDeliveredChart,
    postscriptClicks,
    postscriptClicksChart,
  },
};